export const environment = {
  name: 'staging',
  env: 'Staging',
  production: true,
  cssUrl: 'https://s3.amazonaws.com/sportngin-snap-staging/ui_themes/peacock/latest/main.css',
  localGTMCode: 'GTM-M67J9FB',
  globalGTMCode: 'GTM-KGG8ZWR',
  hqUrl: 'https://app.stage.ngin-staging.com/org/',
  paymentUrl: 'https://se-payments.stage.ngin-staging.com/',
  mySeUrl: 'https://app.stage.ngin-staging.com/user',
  membershipServiceUrl: 'https://membership-service.sestage.us/',
  apiUrl: 'https://se-api.sestage.us/',
  fallbackApiUrl: 'https://api.stage.ngin-staging.com/',
  userUrl: 'https://user.stage.ngin-staging.com',
  nginBarUrl: 'https://ngin-bar.stage.ngin-staging.com/nginbar.js',
  snFrontendUrl: 'https://app.stage.ngin-staging.com',
  snFrontendStaticUrl: 'https://org.stage.ngin-staging.com',
  fallbackSnFrontendStaticUrl: 'https://org.ui.stage.ngin-staging.com',
  sportAdminUrl: 'https://sports.hq.stage.ngin-staging.com',
  seasonManagementUrl: 'https://season-management.ui.stage.ngin-staging.com',
  teamCenterUrl: 'https://team.ui.stage.ngin-staging.com',
  clientId: 'c8a5d5a5ed5e212e361148415691fc91',
  ncsa: {
    event_id: '14900',
    url: 'https://qa.ncsasports.org/api/submit/v1/new_recruit'
  },
  firebase: {
    seBar: {
      apiKey: 'AIzaSyAtcGP-0_8WAuJXz4AtXiEx-Gd-TZJvI0A',
      authDomain: 'sportsengine-staging-77666.firebaseapp.com',
      databaseURL: 'https://sportsengine-staging-se-bar.firebaseio.com/',
      projectId: 'sportsengine-staging-77666',
      storageBucket: 'sportsengine-staging-77666.appspot.com'
    }
  },
  peopleAndOrgsUrl: 'https://people-and-orgs.ui.stage.ngin-staging.com',
  householdSetupUrl: 'https://user.stage.ngin-staging.com',
  seBarUrl: 'https://se-bar.stage.ngin-staging.com/se-bar.js',
  bossUiUrl: 'https://boss.ui.stage.ngin-staging.com/',
  uiThemes: 'https://s3.amazonaws.com/sportngin-snap-staging/ui_themes/assets/latest/images'
}
